/* ==========================================================
   LOFLLY NAVIGATION V8.1 FINAL

   SCROLL-LINKED PERSISTENT GLASS

   ----------------------------------------------------------
   JavaScript 唯一任务：

   scrollY
      ↓
   计算 Black Cover opacity
      ↓
   更新：
   --loflly-cover-opacity


   ----------------------------------------------------------
   0px
   opacity = 1
   FULL BLACK


   0px → 40px
   Smooth Black → Glass


   40px+
   opacity = 0
   FULL GLASS


   ----------------------------------------------------------
   PERFORMANCE:

   - passive scroll
   - requestAnimationFrame
   - no layout measurement
   - no getBoundingClientRect
   - no timeout
   - no transitionend
   - no MutationObserver
   - no resize listener
   - no scroll class toggling
   - no backdrop-filter toggling
   - no repeated DOM write after 40px

   ========================================================== */

(function () {
  'use strict';



  /* ========================================================
     1. VERSION / SINGLETON
     ======================================================== */

  var GLOBAL_KEY =
    '__LOFLLY_NAV_V81__';



  /* ========================================================
     2. CLEAN PREVIOUS LOFLLY NAV VERSIONS

     Shopify Theme Editor 有时不会完整刷新 iframe。

     这一段只在脚本初始化时执行一次。

     正式 storefront 不会持续产生开销。
     ======================================================== */

  var OLD_GLOBALS = [

    '__LOFLLY_GLASS_NAV_V4__',

    '__LOFLLY_SCROLL_GLASS_V5__',

    '__LOFLLY_SCROLL_GLASS_V51__',

    '__LOFLLY_SCROLL_GLASS_V52__',

    '__LOFLLY_SCROLL_GLASS_V53__',

    '__LOFLLY_SCROLL_GLASS_V6__',

    '__LOFLLY_NAV_V7__',

    '__LOFLLY_NAV_V8__',

    GLOBAL_KEY

  ];


  for (
    var i = 0;
    i < OLD_GLOBALS.length;
    i++
  ) {

    var oldInstance =
      window[
        OLD_GLOBALS[i]
      ];


    if (
      oldInstance &&
      typeof oldInstance.destroy === 'function'
    ) {

      try {

        oldInstance.destroy();

      }

      catch (error) {

        /*
         旧实例清理失败，
         绝不能影响 storefront。
        */

      }

    }

  }



  /* ========================================================
     3. MAIN SETTING

     【以后唯一可能需要调的手感参数】

     40px：

     0px
     = 完全 Black

     40px+
     = 完全 Glass


     你现在已经确认 40px 手感不错，
     Final 保持不变。

     如果以后想更慢：
     50 / 60

     如果想更快：
     30
     ======================================================== */

  var FADE_DISTANCE =
    40;



  /* ========================================================
     4. INTERNAL STATE
     ======================================================== */

  var header =
    null;


  var rafPending =
    false;


  var lastOpacity =
    null;



  /* ========================================================
     5. RAF FALLBACK

     现代浏览器使用 requestAnimationFrame。

     极旧环境如果没有：
     自动退化到约 60fps setTimeout。

     不影响导航本身工作。
     ======================================================== */

  var requestFrame =
    window.requestAnimationFrame ||

    function (callback) {

      return window.setTimeout(
        callback,
        16
      );

    };



  /* ========================================================
     6. CHECK WHETHER CACHED HEADER STILL EXISTS

     Shopify Theme Editor
     可能动态替换 Header DOM。

     不依赖 Element.isConnected，
     使用更广泛兼容的 document.contains。
     ======================================================== */

  function isInDocument(
    element
  ) {

    return !!(

      element &&

      document.documentElement &&

      document.documentElement.contains(
        element
      )

    );

  }



  /* ========================================================
     7. GET HEADER
     ======================================================== */

  function getHeader() {

    if (
      isInDocument(
        header
      )
    ) {

      return header;

    }


    header =
      document.getElementById(
        'SiteHeader'
      );


    return header;
  }



  /* ========================================================
     8. GET SCROLL POSITION

     不触发 Layout。

     Safari rubber-band overscroll
     可能暂时出现负值，
     所以最低锁定为 0。
     ======================================================== */

  function getScrollY() {

    var y =
      window.scrollY;


    if (
      typeof y !== 'number'
    ) {

      var scrollingElement =
        document.scrollingElement ||
        document.documentElement;


      y =
        scrollingElement
          ? scrollingElement.scrollTop
          : 0;
    }


    return Math.max(
      0,
      y || 0
    );
  }



  /* ========================================================
     9. CLAMP 0 → 1
     ======================================================== */

  function clamp01(
    value
  ) {

    if (
      value <= 0
    ) {

      return 0;

    }


    if (
      value >= 1
    ) {

      return 1;

    }


    return value;
  }



  /* ========================================================
     10. SMOOTHSTEP

     这是 V8 已经验证手感不错的曲线。

     不使用 linear。

     效果：

     顶部开始变化柔和
     ↓
     中段明显
     ↓
     接近 Glass 时再次减缓


     公式：

     t² × (3 - 2t)
     ======================================================== */

  function smoothstep(
    value
  ) {

    return (

      value *
      value *
      (
        3 -
        (
          2 *
          value
        )
      )

    );

  }



  /* ========================================================
     11. CALCULATE COVER OPACITY

     这里完全是数学运算。

     不读取 DOM geometry。
     ======================================================== */

  function calculateOpacity(
    y
  ) {


    /* ------------------------------------------------------
       Top
       ------------------------------------------------------ */

    if (
      y <= 0
    ) {

      return 1;

    }



    /* ------------------------------------------------------
       Full Glass
       ------------------------------------------------------ */

    if (
      y >=
      FADE_DISTANCE
    ) {

      return 0;

    }



    /* ------------------------------------------------------
       Transition zone
       ------------------------------------------------------ */

    var progress =
      clamp01(
        y /
        FADE_DISTANCE
      );


    var eased =
      smoothstep(
        progress
      );


    var opacity =
      1 -
      eased;



    /*
     3 位小数已经远超肉眼需求。

     减少没有意义的微小 CSS 更新。
    */

    return (

      Math.round(
        opacity *
        1000
      ) /
      1000

    );

  }



  /* ========================================================
     12. UPDATE

     这是唯一写 CSS 的地方。
     ======================================================== */

  function update() {

    rafPending =
      false;


    var element =
      getHeader();


    if (!element) {

      return;

    }


    var opacity =
      calculateOpacity(
        getScrollY()
      );



    /*
     没变化：

     不写 DOM。
    */

    if (
      opacity ===
      lastOpacity
    ) {

      return;

    }


    lastOpacity =
      opacity;



    /*
     整个 V8.1 唯一持续存在的 DOM 写入。
    */

    element.style.setProperty(

      '--loflly-cover-opacity',

      String(
        opacity
      )

    );

  }



  /* ========================================================
     13. RAF SCHEDULER

     一帧最多执行一次 update。
     ======================================================== */

  function scheduleUpdate() {

    if (
      rafPending
    ) {

      return;

    }


    rafPending =
      true;


    requestFrame(
      update
    );

  }



  /* ========================================================
     14. ULTRA-LIGHT SCROLL HANDLER

     这是 Final 版主要性能优化之一。


     情况 A：

     已经 Full Glass
     opacity = 0

     而且用户仍然在 40px 以下页面继续往下滚。

     → 什么都不做
     → 连 RAF 都不启动


     情况 B：

     已经 Top Black
     opacity = 1

     页面仍然是 0。

     → 什么都不做


     只有进入 0–40px 渐变区时，
     才启动 RAF。
     ======================================================== */

  function onScroll() {

    var y =
      getScrollY();



    /* ------------------------------------------------------
       Deep page:
       already full Glass
       ------------------------------------------------------ */

    if (
      lastOpacity === 0 &&
      y >= FADE_DISTANCE
    ) {

      return;

    }



    /* ------------------------------------------------------
       Already at very top
       ------------------------------------------------------ */

    if (
      lastOpacity === 1 &&
      y <= 0
    ) {

      return;

    }



    scheduleUpdate();

  }



  /* ========================================================
     15. BFCache / BACK BUTTON

     Safari / Chrome 返回上一页时，
     可能自动恢复之前的 scroll position。

     pageshow 立即重新同步。
     ======================================================== */

  function onPageShow() {

    lastOpacity =
      null;


    update();

  }



  /* ========================================================
     16. CLEAN LEGACY CLASSES

     只是为了你现在从 V4/V5/V6/V7/V8
     升级到 Final 时不留下旧 class。

     正式使用后基本不会再运行。
     ======================================================== */

  function clearLegacyClasses(
    element
  ) {

    if (
      !element ||
      !element.classList
    ) {

      return;

    }


    element.classList.remove(
      'loflly-nav--scrolled'
    );


    element.classList.remove(
      'loflly-nav--glass'
    );


    element.classList.remove(
      'loflly-nav--closing'
    );


    element.classList.remove(
      'loflly-nav--native-ready'
    );


    element.classList.remove(
      'loflly-nav--instant-release'
    );

  }



  /* ========================================================
     17. SHOPIFY THEME EDITOR REFRESH

     正式 storefront：

     这一部分不会绑定。

     只有 Shopify.designMode 才启用。
     ======================================================== */

  function refreshHeader() {

    if (
      header
    ) {

      clearLegacyClasses(
        header
      );


      header.style.removeProperty(
        '--loflly-cover-opacity'
      );

    }


    header =
      null;


    lastOpacity =
      null;


    update();

  }



  /* ========================================================
     18. EVENTS
     ======================================================== */

  window.addEventListener(

    'scroll',

    onScroll,

    {
      passive: true
    }

  );


  window.addEventListener(

    'pageshow',

    onPageShow

  );



  /* ========================================================
     Theme Editor events：

     Storefront 不绑定，
     进一步减少正式网站监听器。
     ======================================================== */

  var designMode =
    !!(
      window.Shopify &&
      window.Shopify.designMode
    );


  if (
    designMode
  ) {

    document.addEventListener(

      'shopify:section:load',

      refreshHeader

    );


    document.addEventListener(

      'shopify:section:unload',

      refreshHeader

    );

  }



  /* ========================================================
     19. INITIALIZE

     同步执行一次。

     不等待 scroll event。

     正常顶部：
     opacity = 1

     浏览器如果恢复在中间：
     立即计算正确状态。
     ======================================================== */

  var initialHeader =
    getHeader();


  if (
    initialHeader
  ) {

    clearLegacyClasses(
      initialHeader
    );

  }


  update();



  /* ========================================================
     20. DESTROY

     Theme Editor / 未来升级时安全清理。
     ======================================================== */

  function destroy() {


    window.removeEventListener(

      'scroll',

      onScroll,

      {
        passive: true
      }

    );


    window.removeEventListener(

      'pageshow',

      onPageShow

    );


    if (
      designMode
    ) {

      document.removeEventListener(

        'shopify:section:load',

        refreshHeader

      );


      document.removeEventListener(

        'shopify:section:unload',

        refreshHeader

      );

    }


    if (
      header
    ) {

      clearLegacyClasses(
        header
      );


      header.style.removeProperty(
        '--loflly-cover-opacity'
      );

    }


    header =
      null;


    lastOpacity =
      null;

  }



  /* ========================================================
     21. GLOBAL INSTANCE
     ======================================================== */

  window[
    GLOBAL_KEY
  ] = {

    version:
      '8.1.0',

    destroy:
      destroy,

    refresh:
      update

  };

})();
